import VxeTableHeader from './src/header';
import { dynamicApp } from '../dynamics';
export var Header = Object.assign(VxeTableHeader, {
    install: function (app) {
        app.component(VxeTableHeader.name, VxeTableHeader);
    }
});
dynamicApp.component(VxeTableHeader.name, VxeTableHeader);
export default Header;
